export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="41.3991" cy="22.5154" r="11.5154" fill="#CDDBF6" />
    <path
      d="M51.3818 34.3339C52.7434 33.5349 54.4884 33.8912 55.4277 35.16C56.4429 36.5312 56.1543 38.4657 54.7832 39.4808L46.576 45.5572C43.5133 47.8247 39.6918 48.8189 35.9123 48.3314C33.1542 47.9756 30.3543 48.503 27.9146 49.8379L26.6016 50.5563L17.7492 38.5997L18.2774 37.898C20.9659 34.3267 25.6958 32.9699 29.8685 34.573L34.3995 36.3138C35.6089 36.7784 36.8968 37.0039 38.1921 36.9779L41.6674 36.9079L44.1478 36.7463L44.9608 38.1014L51.3818 34.3339Z"
      fill="#8FB4FF"
    />
    <rect
      x="15.2885"
      y="38.6417"
      width="18.1671"
      height="6.58022"
      rx="1.00134"
      transform="rotate(53.4848 15.2885 38.6417)"
      fill="#CDDBF6"
    />
    <path
      d="M31.438 40.1036C31.0041 40.127 30.6714 40.4977 30.6948 40.9316C30.7182 41.3655 31.0889 41.6982 31.5228 41.6748L31.438 40.1036ZM42.8169 39.4894L31.438 40.1036L31.5228 41.6748L42.9017 41.0606L42.8169 39.4894ZM41.393 36.968L42.677 36.8987L42.5922 35.3275L41.3082 35.3968L41.393 36.968ZM44.0423 38.1241C44.0809 38.8395 43.5323 39.4508 42.8169 39.4894L42.9017 41.0606C44.4848 40.9752 45.699 39.6225 45.6135 38.0393L44.0423 38.1241ZM45.6135 38.0393C45.5281 36.4562 44.1754 35.242 42.5922 35.3275L42.677 36.8987C43.3924 36.8601 44.0037 37.4088 44.0423 38.1241L45.6135 38.0393Z"
      fill="white"
    />
    <path
      d="M41.4376 15.3363V22.3827L46.0449 26.9899"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
